"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _batteryWare = require("@/api/iot/batteryWare");
var _deviceType = require("@/api/iot/deviceType");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _editDialog = _interopRequireDefault(require("./dialog/editDialog"));
var _default = {
  components: {
    customPage: _customPage.default,
    editDialog: _editDialog.default
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        merchant_id: '',
        terminal_no: '',
        device_type_id: '',
        battery_no: '',
        status: '',
        door_status: '',
        is_battery: '',
        charge_status: ''
      },
      total: 0,
      tableData: [],
      deviceTypeList: [],
      chargeStatusList: [],
      editItem: null,
      merchantList: []
    };
  },
  mounted: function mounted() {
    this.init();
    this.getList();
    this.getDeviceTypeList();
    this.getChargeStatusList();
  },
  methods: {
    init: function init() {
      if (this.sMerchantId == 0) {
        this.getMerchantList();
      }
      this.loadQuery();
    },
    loadQuery: function loadQuery() {
      var query = this.$route.query;
      for (var key in this.searchForm) {
        if (query[key]) {
          this.searchForm[key] = query[key];
        }
      }
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getDeviceTypeList: function () {
      var _getDeviceTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _deviceType.deviceTypeList)();
              case 2:
                res = _context2.sent;
                if (res) {
                  this.deviceTypeList = res;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getDeviceTypeList() {
        return _getDeviceTypeList.apply(this, arguments);
      }
      return getDeviceTypeList;
    }(),
    getList: function getList(flag) {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.loading = true;
        this.tableData = [];
      }
      (0, _batteryWare.batteryWareList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.loading = false;
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    },
    // 检测充电状态
    chkChargeStatusType: function chkChargeStatusType(status) {
      var type = 'info';
      if (status >= 10) {
        type = 'danger';
      } else if (status > 1) {
        type = 'success';
      }
      return type;
    },
    getChargeStatusList: function getChargeStatusList() {
      var _this2 = this;
      (0, _batteryWare.getChargeStatusList)().then(function (res) {
        _this2.chargeStatusList = res || [];
      });
    },
    // 编辑
    openEditDialog: function openEditDialog(val) {
      this.editItem = val || null;
      this.$refs.editDialog.dialogVisible = true;
    },
    // 分润
    openBenefitDialog: function openBenefitDialog(val) {
      this.editItem = val || null;
      this.$refs.benefitDialog.dialogVisible = true;
    },
    // 删除
    removeItem: function removeItem(item) {
      var _this3 = this;
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _batteryWare.batteryWareDel)({
          id: item.id
        }).then(function (res) {
          _this3.getList(true);
        });
      }).catch(function () {});
    },
    // 修改电池仓状态
    editStatus: function editStatus(item, status) {
      var _this4 = this;
      var title = status ? '启用电池仓' : '停用电池仓';
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u6267\u884C ".concat(title, " \u64CD\u4F5C\u5417?"), title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var param = {
          id: item.id,
          status: status
        };
        (0, _batteryWare.batteryWareSave)(param).then(function (res) {
          _this4.getList(true);
        });
      }).catch(function () {});
    },
    // 开门
    openDoor: function openDoor(item) {
      var _this5 = this;
      this.$confirm('您确定要执行 开门 操作吗?', '开门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _batteryWare.batteryWareOpen)({
          id: item.id
        }).then(function (res) {
          _this5.getList(true);
        });
      }).catch(function () {});
    },
    // 充电开/关指令
    charge: function charge(item) {
      var isCharge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var str = isCharge ? '充电开' : '充电关';
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u6267\u884C ".concat(str, " \u64CD\u4F5C\u5417?"), '充电开', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var param = {
          id: item.id,
          charge_status: isCharge
        };
        (0, _batteryWare.setCharge)(param).then(function (res) {});
      }).catch(function () {});
    },
    // 下发电柜状态查询指令
    cabinetQueryInfo: function cabinetQueryInfo(item) {
      var _this6 = this;
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u67E5\u8BE2\u7535\u67DC\u72B6\u6001\u64CD\u4F5C\u5417?", '查询电柜状态', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var param = {
          id: item.id
        };
        (0, _batteryWare.cabinetQueryInfo)(param).then(function (res) {
          setTimeout(function () {
            _this6.getList(true);
          }, 5 * 1000);
        });
      }).catch(function () {});
    },
    // 清除
    clear: function clear(item) {
      this.$confirm('您确定要执行 清除 操作吗?', '清除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 跳转到电池
    jumpBattery: function jumpBattery() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$h5.href({
        name: 'chkgBattery',
        query: {
          battery_no: item.battery_no
        }
      }, 1);
    },
    jumpMingtang: function jumpMingtang(item) {
      if (item.macid && item.battery_type_id && item.battery_type_id == 1) {
        var url = 'https://bms.mtxnyjs.com/front/clocation/admin.html#/monitoring/index?number=' + item.macid;
        window.open(url, '_blank');
      }
    },
    // 跳转到换电记录
    jumpExchangeRecord: function jumpExchangeRecord() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$h5.href({
        name: 'iotOrderExchangeRecord',
        query: {
          terminal_no: item.terminal_no,
          warehouse_no: item.warehouse_no
        }
      }, 1);
    },
    // 跳转到用户开仓记录
    jumpOpenBwLog: function jumpOpenBwLog() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$h5.href({
        name: 'iotLogIotOpenBwLog',
        query: {
          terminal_no: item.terminal_no,
          warehouse_no: item.warehouse_no
        }
      }, 1);
    },
    searchFilter: function searchFilter(field) {
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!field) {
        return;
      }
      this.searchForm[field] = item[field];
      this.search();
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    }
  }
};
exports.default = _default;